import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SocialLinks from '../components/SocialLinks';

const CommunautePage = () => {
  useEffect(() => {
    document.title = 'Communauté — MonAlerte';
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <SocialLinks />
      </main>
      <Footer />
    </>
  );
};

export default CommunautePage;
